import CloseChallengeForm from './CloseChallengeForm';

export default CloseChallengeForm;
